import type { Appointment, AppointmentStatus } from "@myapp/contract";

type AppointmentLike = Pick<Appointment, "status" | "schedule">;

const COMPLETED_STATUSES: AppointmentStatus[] = ["COMPLETED", "COMPLETED_WITH_FOLLOW_UP"];

/**
 * Mirrors the guard in `DeleteAppointmentUseCase`: work that already happened is a record, not a
 * plan, so a completed or already-started Termin cannot be removed. The API answers those with
 * 409 `APPOINTMENT_DELETE_FORBIDDEN` — offering the button anyway would only produce an error the
 * user can do nothing about, which is why the row hides it instead.
 *
 * "Started" is the presence of `actualWorkStartsAt`, not a status: a PLANNED appointment the
 * technician has begun is undeletable too.
 */
export const canDeleteAppointment = (appointment: AppointmentLike): boolean =>
  !COMPLETED_STATUSES.includes(appointment.status) &&
  appointment.schedule.actualWorkStartsAt == null;
